function ContactController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var MAP_INIT_RETRY_MAX = 10;
	
	
	/* PRIVATE VARIABLES */
	var mapContainer;
	var mapInitRetryCount = 0;
	var officeMap = null;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	


	function mapInitCallback(){
		mapInitRetryCount ++;
		if (mapApiInited) {
			initMap();
		} else {
			if (mapInitRetryCount < MAP_INIT_RETRY_MAX) {
				setTimeout(mapInitCallback, 1000);
			}
		}
	}
	

	function initMap(){
		if(mapContainer.length === 1){
			officeMap = new OfficeMap(mapContainer);
		}
	}
	
	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// object references
			mapContainer = $('#map-container');		
			
			// init
			var contactForm = new ContactForm($('#contact-form-container'));

			mapInitCallback();

			_this.inited = true;
		}
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
